import { defineMessages } from 'react-intl';

export const interestsTranslations = defineMessages({
    atLeastOne: {
        id: 'Interests.form.validation.atLeastOne',
        defaultMessage: 'Select at least one interest and gif.'
    }
});
